import { C1Chip } from 'c1ui/components/C1Chip'
import { C1DisplayNameSkeleton } from 'components/core/display-name-details'
import { C1EmptyIndicator } from 'components/core/empty-indicator/C1EmptyIndicator'
import { MinimalAPIError } from 'components/core/errors/api'
import { FC } from 'react'
import { FormattedMessage } from 'react-intl'
import { getAppEntitlementApi } from 'redux_toolkit/entitlements'

type EntitlementDisplayNameWithFetchProps = {
    entitlementId: string
    appId: string
}

export const EntitlementSlugWithFetch: FC<EntitlementDisplayNameWithFetchProps> = ({ entitlementId, appId }) => {
    const {
        data: entitlement,
        error,
        isLoading,
        isError,
    } = getAppEntitlementApi.useGet(
        {
            appId,
            id: entitlementId,
            expandMask: { paths: ['*'] },
        },
        { actionable: !!entitlementId },
    )

    // Interestingly on a task restart, on first notify, we can get task without an entitlement id
    if (isLoading) {
        return <C1DisplayNameSkeleton />
    }

    if ((isError && error) || !entitlement) {
        const err = (
            <FormattedMessage id="component_api_error_entitlement" defaultMessage="Error fetching entitlement" />
        )
        return <MinimalAPIError err={err} />
    }

    if (!entitlement.slug) {
        return <C1EmptyIndicator />
    }

    return <C1Chip label={entitlement.slug} />
}
